/* MS2 — indicador de carrossel em segmentos.
   Inicializa qualquer bloco [data-ms2-carousel] que contenha uma trilha
   .ms2-carousel e um indicador [data-ms2-dots].

   Nota de ambiente: o preview da Shopify (e alguns webviews) não emitem
   'scroll' em container interno nem executam requestAnimationFrame de forma
   confiável — por isso a sincronização usa setTimeout e é reaberta a cada
   interação, em vez de depender só do evento de scroll. */
(function () {
  function init(root) {
    if (!root || root.dataset.ms2CarouselInit === '1') return;
    var track = root.querySelector('.ms2-carousel');
    var dotsWrap = root.querySelector('[data-ms2-dots]');
    if (!track || !dotsWrap) return;
    root.dataset.ms2CarouselInit = '1';

    var dots = [].slice.call(dotsWrap.querySelectorAll('.ms2-dots__item'));
    var cells = [].slice.call(track.children);
    if (!dots.length || !cells.length) return;

    function cellStart(i) {
      return cells[i].getBoundingClientRect().left
           - track.getBoundingClientRect().left
           + track.scrollLeft;
    }

    function sync() {
      var r = track.getBoundingClientRect();
      // item cujo início está mais próximo da borda esquerda da trilha
      var active = 0, menor = Infinity;
      cells.forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - r.left);
        if (d < menor) { menor = d; active = i; }
      });
      // no fim da rolagem, marca o último
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) {
        active = cells.length - 1;
      }
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
    }

    var pumping = false, until = 0;
    function pump() {
      sync();
      if (Date.now() < until) setTimeout(pump, 60);
      else pumping = false;
    }
    function track_(ms) {
      until = Date.now() + (ms || 900);
      if (!pumping) { pumping = true; pump(); }
    }

    track.addEventListener('scroll', function () { track_(400); }, { passive: true });
    ['touchstart', 'touchmove', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, function () { track_(1500); }, { passive: true });
    });

    dotsWrap.querySelectorAll('[data-ms2-dot]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.dataset.ms2Dot, 10);
        if (cells[i]) track.scrollTo({ left: cellStart(i), behavior: 'smooth' });
        track_(1200);
      });
    });

    window.addEventListener('resize', function () { track_(300); });
    sync();
  }

  /* Accordions exclusivos: abrir um fecha os outros do mesmo grupo.
     O HTML já faz isso via <details name="…">, mas navegadores antigos
     ignoram o atributo — este reforço garante o comportamento em todos. */
  var nativo = (function () {
    var d = document.createElement('details');
    return 'name' in d;
  })();

  function initAccordions() {
    if (nativo) return;
    document.querySelectorAll('details[name]').forEach(function (det) {
      if (det.dataset.ms2AccInit === '1') return;
      det.dataset.ms2AccInit = '1';
      det.addEventListener('toggle', function () {
        if (!det.open) return;
        var grupo = det.getAttribute('name');
        document.querySelectorAll('details[name="' + grupo + '"]').forEach(function (outro) {
          if (outro !== det) outro.open = false;
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ms2-carousel]').forEach(init);
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // editor de tema: recarrega seções isoladamente
  document.addEventListener('shopify:section:load', initAll);
})();
